export const LOAN_CHAT_UNREAD_BADGE_MAX_DISPLAY = 99;

export const LOAN_EDITOR_CHAT_DRAWER_MIN_WIDTH = 360;
export const LOAN_EDITOR_CHAT_DRAWER_MAX_WIDTH = 560;
export const LOAN_EDITOR_CHAT_DRAWER_DEFAULT_WIDTH = 400;

export const LoanEditorChatDrawerStorageKey = {
  OPEN: 'teamChat.loanEditorDrawer.open',
  WIDTH: 'teamChat.loanEditorDrawer.width',
};

export const DRAWER_MODAL_PROPS = { keepMounted: true };

export const DRAWER_FALLBACK_TITLE = 'Loan chat';

export const LoanEditorChatChannelKey = {
  INTERNAL: 'internal',
  TPO: 'tpo',
};

export const LOAN_EDITOR_CHAT_CHANNEL_LABEL = {
  [LoanEditorChatChannelKey.INTERNAL]: 'Internal',
  [LoanEditorChatChannelKey.TPO]: 'TPO Broker',
};

export const ESCALATE_TPO_CHAT_LABEL = 'Escalate';

export const ESCALATE_TPO_CHAT_TOOLTIP = 'Pull in the next escalation tier';
